import React from "react";
import { Typography, Button, Box, Link } from "@mui/material";
import styles from "../../Routes/Schedule/Schedule.module.css";

import scheduleHeroBannerImage from "../../assets/BannerImages/ScheduleBanner.jpg";

const ScheduleHero = () => {
  const scrollToCalendar = () => {
    const calendarEl = document.getElementById("calendar-section");
    if (calendarEl) {
      calendarEl.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      className={` ${styles.sectionWrapper}`}
      style={{ "--hero-bg": `url(${scheduleHeroBannerImage})` }}
    >
      <Box className={`${styles.heroContainer}`}>
        <Typography variant="h4" className={styles.heroTitle}>
          Book Your 1:1 Solar Consultation
        </Typography>
        <Typography variant="subtitle1" className={styles.heroSubtitle}>
          Personalized guidance to see if solar fits your home or business.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={scrollToCalendar}
          className={styles.heroButton}
        >
          Book Now
        </Button>

        <Typography variant="body2" className={styles.signInPrompt}>
          Already a customer?{" "}
          <Link href="/login" underline="hover" color="primary">
            Sign in
          </Link>{" "}
          to manage follow-up inquiries.
        </Typography>
      </Box>
    </div>
  );
};

export default ScheduleHero;
